import React from "react";
import Devices  from "../modules/DevicesFacilityReport/Devices";
export default function DevicesFacilityReportPage() {
  return <Devices />;
}
